import { VocTerm } from './voc-term';

export class SifaSelection {
    private _section: VocTerm = null;
    private _part: VocTerm = null;
    private _treatise: VocTerm = null;
    private _chapter: VocTerm = null;
    private _otherElement: VocTerm = null;

    set section(value: VocTerm) {
        this._section = value;
        this._part = null;
        this._treatise = null;
        this._chapter = null;
        this._otherElement = null;
    }
    get section(): VocTerm {
        return this._section;
    }

    set part(value: VocTerm) {
        this._part = value;
        this._treatise = null;
        this._chapter = null;
        this._otherElement = null;
    }
    get part(): VocTerm {
        return this._part;
    }

    set treatise(value: VocTerm) {
        this._treatise = value;
        this._chapter = null;
        this._otherElement = null;
    }
    get treatise(): VocTerm {
        return this._treatise;
    }

    set chapter(value: VocTerm) {
        this._chapter = value;
        this._otherElement = null;
    }
    get chapter(): VocTerm {
        return this._chapter;
    }

    set otherElement(value: VocTerm) {
        this._otherElement = value;
        this._section = null;
        this._part = null;
        this._treatise = null;
        this._chapter = null;
    }
    get otherElement(): VocTerm {
        return this._otherElement;
    }

    isNull(): boolean {
        return this._section === null
            && this._part === null
            && this._treatise === null
            && this._chapter === null
            && this._otherElement === null;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/sifa-selection.ts